<template>
  <div class="notification">
    <div class="notification__icon">
      <fa icon="info-circle"></fa>
    </div>
    <div class="notification__content">
      <div class="notification__summary">
        <div>{{ notification.summary }}</div>
      </div>
      <div
        :key="'notification_content' + index"
        v-for="(p, index) in notification.content"
        class="notification__content"
      >
        {{ p }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: { type: Object },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  border: 3px solid #8a4e94;
  padding: 20px;
  margin-bottom: 15px;

  @media screen and (max-width: 425px) {
    width: 300px;
  }

  &__icon {
    margin-right: 10px;
    color: #8a4e94;

    svg {
      font-size: 1.3rem;
    }
  }
  &__summary {
    font-weight: bold;
  }
}
</style>
